import emojiRegex from '@/utils/libs/emojiRegex';

/** 移除多余空格 */
export function removeBlank(str = '') {
  /**
   * 1、除去前后空格
   * 2、多个空格合并成一个
   */
  str = str.trim().replace(/\s+/g, ' ');
  return str;
}

/** 移除emoji表情 */
export function removeEmoji(str: string) {
  return str.replace(emojiRegex, '');
}

/** 移除非法字符(半角) */
export function removeInvalidCharacterHalfWidth(str: string) {
  return str.replace(/[~!@#$%^&*()\-+={}|:"<>?`[\]\\;',./]/g, '');
}

/** 移除非法字符(全角) */
export function removeInvalidCharacterFullWidth(str: string) {
  return str.replace(/[·～！@#¥%……&*（）——+「」『』｜：“”《〈〉》？【】、；‘，。/]/g, '');
}

/** 修正输入字符串 */
export function searchInputCorrection(str: string = '') {
  str = removeBlank(str);
  str = removeEmoji(str);
  str = removeInvalidCharacterHalfWidth(str);
  str = removeInvalidCharacterFullWidth(str);
  return str;
}
